; (function () {

    addEventListener("DOMContentLoaded", (event) => {
        // theme.liquidで渡されたasset_urlを取得
        const asset_url = window.indexCampaign ?  window.indexCampaign.asset_url : '';
        const bannerList = [
            // 2BUY 10%OFFキャンペーン 8/4 11:00 ～ 8/31 17:00
            {
                'banner_pc': `${asset_url}2buy_202608_pc.png`,
                'banner_sp': `${asset_url}2buy_202608_sp.png`,
                'banner_url': 'https://www.wb-ookura.com/kaitori/news/43232/',
                'banner_alt': '2BUY 10%OFFキャンペーン',
                'start_date': '2026-08-04T11:00:00',
                'end_date':   '2026-08-31T17:00:00',
            },
        ]

        //セール用 帯バナー
        const headerBannerWrapper = document.querySelector('.js-header-banner-wrapper');

        //時限設定
        let nowDateTime = new Date();
        const searchParams = new URLSearchParams(window.location.search);
        const testDateParam = searchParams.get('testdate'); // 日時文字列形式 YYYY-MM-DDTHH:mm:ss

        if (testDateParam) {
            nowDateTime = new Date(testDateParam);
        }

        //期間中のキャンペーンデータを抽出
        const bannerData = bannerList.filter((cp) => {
            //掲載期間外の場合、次のループへ
            const startDateTime = cp.start_date ? new Date(cp.start_date) : null;
            const endDateTime = cp.end_date ? new Date(cp.end_date) : null;
            if (startDateTime && !(startDateTime <= nowDateTime)) return false;
            if (endDateTime && !(nowDateTime < endDateTime)) return false;

            return cp;
        });

        //キャンペーン期間中
        if (bannerData) {

            const bannerHTML = bannerData.filter(banner => banner.banner_pc && banner.banner_sp)
            .map((banner) => {
                const html = 
                `
                <div class="Header__banner js-header-banner" style="background-image: url(${banner.banner_pc || ''});">
                    <a href="${banner.banner_url || ''}">
                        <img class="Header__banner_img_sp" src="${banner.banner_sp || ''}" alt="${banner.banner_alt || ''}" width="750" height="100"/>
                    </a>
                </div>
                `
                return html;
            });

            if (bannerHTML.length && headerBannerWrapper) {
                headerBannerWrapper.insertAdjacentHTML('beforeend', bannerHTML.join(''))
                headerBannerWrapper.style.opacity = '1';
            }

        //キャンペーン期間外
        } else {

            //セール用 帯バナーを非表示
            if (headerBannerWrapper) {
                headerBannerWrapper.style.display = 'none';
            }
        }

    });
}());